export function goToLink(link: string, blank = true) {
  const newWindow = window.open(link, blank ? '_blank' : '_self')
  if (!newWindow) {
    window.location.href = link
  }
}
